/**
 * OverviewPanel - Total Records + Conduct Score metrics
 */

import { Skeleton } from '../../../../../ui/skeleton';
import { cn } from '../../../../../../lib/utils';
import type { OverviewPanelProps } from '../../types';
import { MetricCard } from '../molecules';

export function OverviewPanel({
  data,
  isLoading,
  isError,
  className
}: OverviewPanelProps) {
  if (isLoading) {
    return (
      <div className={cn('grid grid-cols-1 md:grid-cols-2 gap-4', className)} aria-busy="true">
        <Skeleton className="h-40 rounded-[24px]" />
        <Skeleton className="h-40 rounded-[24px]" />
      </div>
    );
  }

  if (isError) {
    return (
      <div className={cn('grid grid-cols-1 md:grid-cols-2 gap-4', className)} data-testid="overview-panel">
        <div className="flex h-40 items-center justify-center rounded-[24px] border border-border/70 bg-background/90 text-destructive shadow-[var(--shadow-card)]">
          Failed to load overview data
        </div>
        <div className="flex h-40 items-center justify-center rounded-[24px] border border-border/70 bg-background/90 text-destructive shadow-[var(--shadow-card)]">
          Failed to load overview data
        </div>
      </div>
    );
  }

  if (!data) {
    return null;
  }

  return (
    <div
      className={cn('grid grid-cols-1 md:grid-cols-2 gap-4', className)}
      data-testid="overview-panel"
    >
      <MetricCard
        title="Aggregate Conduct Score"
        value={data.avgConductScore}
        delta={data.avgConductScoreDelta}
        deltaLabel="vs previous period"
        format="score"
        trendPositive="down"
        trendData={data.avgConductScoreTrend}
      />

      <MetricCard
        title="Total Records"
        value={data.totalRecords}
        delta={data.totalRecordsDelta}
        deltaLabel="vs previous period"
        format="number"
        trendPositive="down"
        trendData={data.totalRecordsTrend}
      />
    </div>
  );
}
